export const SEARCH_FACET_END_TOKEN = ':';
export const SEARCH_DELIMITER = ' ';
export const MUST_TOKEN = '+';
export const MUST_NOT_TOKEN = '-';
// eslint-disable-next-line @sas/i18n/jsx-to-localize
export const PREVIOUS_DAY_SEARCH_VALUE = 'Previous day';
export const NESTED_FACET_SYNTAX_SUFFIX_LABEL = ' {  }';
export const NESTED_FACET_SYNTAX_SUFFIX_VALUE = ' {  }';
// -2 to place the cursor between the two curly braces with one space on either side
export const NESTED_FACET_CURSOR_OFFSET = -2;
//# sourceMappingURL=shared.js.map